import React from 'react';
import { PanelResizeHandle } from 'react-resizable-panels';

export function ResizeHandle() {
  return (
    <PanelResizeHandle className="w-1.5 hover:bg-gray-300 transition-colors">
      <div className="h-full w-full bg-gray-200" />
    </PanelResizeHandle>
  );
}

export function VerticalResizeHandle() {
  return (
    <PanelResizeHandle className="h-1.5 hover:bg-gray-300 transition-colors">
      <div className="h-full w-full bg-gray-200" />
    </PanelResizeHandle>
  );
}